export default {
  'avoidingDeductiveArguments': {
    'course-title': 'Avoiding Deductive Arguments',
    'course-name': 'Section 3C <span class="unit-title">Avoiding Deductive Arguments<span>',
    'course-video': {
      'title': 'Section 3 SUPPORTING THE POINTS<br/>1’13:09 – 1’15:53 3D AVOIDING DEDUCTIVE ARGUMENTS.<br/>End Section (no exercise)',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '3C Lecture'
    },
    'congratulation-message': 'Congratulations',
    'finish-section': 'You have completed all of Section 3 of the Course',
    'final-description': 'You understand how to support your points both inductively and deductively,<br/>preferably inductively',
    'next-course-button': 'proceed to section 4',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3c/avoidingDeductiveArguments/i18n/en.js